import { Navigate, RouteObject } from "react-router-dom";
import HomePageSSR from "../pages/HomePage/HomePageSSR";
import Login from "../pages/Login/Login";
import ConfirmLoginPage from "../pages/ConfirmLoginPage/ConfirmLoginPage";
import ForgotpasswordPage from "../pages/ForgotPasswordPage/ForgotPasswordPage";
import ResetPasswordPage from "../pages/ForgotPasswordPage/ResetPasswordPage";
import ModifyPassword from "../pages/ForgotPasswordPage/ModifyPassword";
import IconTest from "../pages/IconTest";
import InputComponentsTest from "../pages/InputComponentsTest/InputComponentsTest";
import ViewMode from "../pages/ProfileViewMode/ViewMode";
import TwoFactorAuth from "../pages/Login/TwoFactorAuth";
import AboutUs from "../pages/AboutUs/AboutUs";
import Benefits from "../pages/AboutUs/Benefits";
import Objectives from "../pages/AboutUs/Objectives";
import Join from "../pages/AboutUs/Join";
import Board from "../pages/AboutUs/Board";
import Council from "../pages/AboutUs/Council";
import GoogleCallback from "../pages/Auth/GoogleCallback";
import LinkedInCallback from "../pages/Auth/LinkedInCallback";
import SimpleLogin from "../pages/Login/SimpleLogin";
import { EventRoutes } from "./EventRoutes";
import MemberEvents from "../pages/Events/MemberEvents";
import UnsubscribedConfirmation from "../pages/UnsubscribedConfirmation";
import PublicEmailSubscriptionsPage from "../pages/PublicEmailSubscriptionsPage";
import LegacyUnsubscribeBridge from "../pages/LegacyUnsubscribeBridge";
import ProfileMemberOverviewPage from "../pages/ProfileEditMode/ProfileMemberOverviewPage";
import EditMyProfilePage from "../pages/ProfileEditMode/EditMyProfilePage";
import PublicFirmProfileV2 from "../pages/FirmProfile/PublicFirmProfileV2";
import MemberSearchPage from "../pages/MemberSearch/MemberSearchPage";
import Contact from "../pages/Contact/Contact";
import { isNewMemberSearchEnabled } from "../Enums/LegacyRedirection";
import { ADVANCED_MEMBER_SEARCH_PATH } from "../utils/memberSearchNavigation";

export const PublicRoutes: RouteObject[] = [
  {
    path: "/",
    element: <HomePageSSR />,
  },
  {
    path: "/default.asp",
    element: <Navigate to="/" replace />,
  },
  {
    path: "/profile/attorney/:userId",
    element: <ViewMode />,
  },
  {
    path: "/profile/attorney/:customPath/:generatedId",
    element: <ViewMode />,
  },
  {
    path: "/profile2/:customPath/:generatedId",
    element: <ProfileMemberOverviewPage />,
  },
  {
    path: "/member2/:firmType/:slug/:id",
    element: <PublicFirmProfileV2 />,
  },
  {
    path: "/profile2/:customPath/:generatedId/edit",
    element: <EditMyProfilePage />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/aboutus",
    element: <AboutUs />,
  },
  {
    path: "/benefits",
    element: <Benefits />,
  },
  {
    path: "/objectives",
    element: <Objectives />,
  },
  {
    path: "/join",
    element: <Join />,
  },
  {
    path: "/board",
    element: <Board />,
  },
  {
    path: "/councils",
    element: <Council />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/confirmlogin",
    element: <ConfirmLoginPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotpasswordPage />,
  },
  {
    path: "/support-test-forgot-password",
    element: <ForgotpasswordPage debug={true} />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/newUser/:userName/:code",
    element: <ModifyPassword firstTime />,
  },
  {
    path: "/reset-password/:userName/:code",
    element: <ModifyPassword />,
  },
  ...EventRoutes,
  ...(process.env.REACT_APP_ENVIRONMENT !== "prod"
    ? [
        {
          path: "test-icon",
          element: <IconTest />,
        },
        {
          path: "/test-input-components",
          element: <InputComponentsTest />,
        },
      ]
    : []),
  {
    path: "/two-factor-auth",
    element: <TwoFactorAuth />,
  },
  {
    path: "/auth/google/callback",
    element: <GoogleCallback />,
  },
  {
    path: "/auth/linkedin/callback",
    element: <LinkedInCallback />,
  },
  {
    path: "/link-account-login",
    element: <SimpleLogin />,
  },
  {
    path: "/events",
    element: <MemberEvents />,
  },
  {
    path: "/email-subscriptions",
    element: <PublicEmailSubscriptionsPage />,
  },
  {
    path: "/unsubscribed",
    element: <UnsubscribedConfirmation />,
  },
  {
    path: "/email-subscription.asp",
    element: <LegacyUnsubscribeBridge />,
  },
  {
    path: "/press-subscription.asp",
    element: <LegacyUnsubscribeBridge defaultType="press" />,
  },
  {
    path: "/networkwire-subscription.asp",
    element: <LegacyUnsubscribeBridge defaultType="networkwire" />,
  },
  {
    path: "/publications-subscription.asp",
    element: <LegacyUnsubscribeBridge defaultType="networkwire" />,
  },
  {
    path: "/stories-subscription.asp",
    element: <LegacyUnsubscribeBridge defaultType="success" />,
  },
  {
    path: "/member-search",
    element: isNewMemberSearchEnabled() ? (
      <MemberSearchPage />
    ) : (
      <Navigate to="/search-special.asp" replace />
    ),
  },
  ...(!isNewMemberSearchEnabled()
    ? [
        {
          path: ADVANCED_MEMBER_SEARCH_PATH,
          element: <Navigate to="/advanced-search.asp" replace />,
        },
      ]
    : []),
];
